import { defineMessages } from 'react-intl';

type MessageKeys = 'moreButton' | 'loadMoreButton';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		moreButton: {
			id: 'ai-mate.conversation-assistant-agent.agents-list-fullscreen.agent-section.more',
			defaultMessage: 'More',
			description: 'More button text for agent section',
		},
		loadMoreButton: {
			id: 'ai-mate.conversation-assistant-agent.agents-list-fullscreen.agent-section.load-more-button',
			defaultMessage: 'Load more',
			description: 'Load more button text for agent section',
		},
	});

export default message;
